import React, { useEffect, useRef, useState } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import Layout from "../components/layout";
import HeroSection from "../screens/heroSection";
import Plans from "../screens/plans";
import { Link } from "react-router-dom";
import { MdOutlineChevronRight } from "react-icons/md";
import HeroVideoSection from "../screens/heroVideoSection";
import BrandSection from "../components/brandSection";
import "./cardanimation.css"
import CustomButton from "./custombutton";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import { FaStoreAlt } from "react-icons/fa";
import { FaChevronLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa6";
import "slick-carousel/slick/slick-theme.css";
import { Building, Layers, Plug, ShieldCheck, TrendingUp } from "lucide-react";
import { FaHandPointRight } from "react-icons/fa";
import { FaUserTie, FaShoppingCart, FaCog, FaTruck, FaPrescriptionBottleAlt, FaUserAlt, FaUsers, FaBullhorn } from "react-icons/fa";
import { FaLaptopCode, FaChartBar, FaClipboardCheck, FaTags, FaStore, FaBoxOpen, FaChartPie } from 'react-icons/fa';
import { FaChartLine, FaRobot, FaProjectDiagram, FaRocket, FaIndustry, FaGlobe, FaFileContract, FaCheckCircle, FaBoxes, FaHandshake, FaShoppingBag, FaWarehouse, } from "react-icons/fa";

const Home = () => {

  const products = [
    {
      id: 1,
      link: "/products/sales/inficonnect",
      imgSrc: "/inficonnectLogoPrevious.png",
      alt: "inficonnect Icon",
      title: "infiConnect",
    },
    {
      id: 2,
      link: "/products/sales/zeroclik",
      imgSrc: "/zeroclickLogo.svg",
      alt: "zeroclick Icon",
      title: "0Click",
    },
    {
      id: 3,
      link: "/products/sales/xpressbazaar",
      imgSrc: "/expressbazaarLogo.png",
      alt: "ExpressBazaar Icon",
      title: "xpressbazaar",
    },
    {
      id: 4,
      link: "/products/sales/qwikco",
      imgSrc: "/qwikcoLogo.png",
      alt: "QwikcoLogo Icon",
      title: "Qwikco",
    },
    {
      id: 5,
      link: "/products/sales/connect-plus",
      imgSrc: "/connectPlus/logo.png",
      alt: "connectplus Icon",
      title: "connectPlus",
    },
    {
      id: 6,
      link: "/products/sales/victor",
      imgSrc: "/victor/logo.png",
      alt: "Victor Icon",
      title: "Victor",
    },
    {
      id: 7,
      link: "/products/sales/genius",
      imgSrc: "/genius/logo.png",
      alt: "Genius Icon",
      title: "Genius",
    },
    {
      id: 8,
      link: "/products/sales/shop-sense",
      imgSrc: "/shopSense/logo.png",
      alt: "ShopSense Icon",
      title: "SopSense",
    },
  ];

  const [counters, setCounters] = useState({
    uptime: 0,
    users: 600,
    countries: 0,
    transactions: 0,
    teams: 1000,
  });

  const sectionRef = useRef(null);

  const animateCounters = () => {
    let start = Date.now();
    const duration = 2000;

    const targetValues = {
      uptime: 30,
      users: 3000,
      countries: 12,
      transactions: 4200,
      teams: 10000,
    };

    const step = () => {
      const elapsed = Date.now() - start;
      const progress = Math.min(elapsed / duration, 1);

      setCounters({
        uptime: +(progress * targetValues.uptime).toFixed(2),
        users: Math.floor(progress * targetValues.users),
        countries: Math.floor(progress * targetValues.countries),
        // transactions: +(progress * targetValues.transactions).toFixed(2),
        transactions: Math.floor(progress * targetValues.transactions),
        teams: Math.floor(progress * targetValues.teams),
      });

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    step();
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          animateCounters();
          // observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();

  }, []);

  const testimonials = [
   
 
    {
      id: 3,
      quote: "The customer support and features are top-notch. A game-changer for our team!",
      name: "Michael Lee",
      title: "CEO at Innovate Solutions",
      img: "https://media.istockphoto.com/id/1409948464/photo/business-portrait.jpg?s=612x612&w=0&k=20&c=UUfD4mgds-bcgL8Q3QsDKzgwJIqwQ9vwpXp7LiWOZ7U=",
      color: 'linear-gradient(90deg, #e0f7fa, #b2ebf2)',
    },

    {
      id: 5,
      quote: "Intuitive, powerful, and reliable—this platform has everything we need.",
      name: "James Walker",
      title: "CTO at DevNest",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKDL65BNvzzEzgJH2hpKtuO3zCbh8yryRSTA&s",
      color: 'linear-gradient(90deg, #e0ffe0, #b2fab4)',
    },

    {
      id: 7,
      quote: "We were up and running in no time. The interface is user-friendly and efficient.",
      name: "David Patel",
      title: "Founder at StartRight",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRTpUJUFYstvXBuWsxjzB4vCbKLmoP93yuNQ&s",
      color: 'linear-gradient(90deg, #f3e5f5, #ce93d8)',
    },
    {
      id: 8,
      quote: "Absolutely love how it simplifies complex processes. Our team can’t imagine working without it.",
      name: "John smith",
      title: "Lead Designer at PixelWave",
      img: "https://www.kindpng.com/picc/m/586-5865544_testimonial-image-gentleman-hd-png-download.png",
      color: 'linear-gradient(90deg, #e1f5fe, #81d4fa)',
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  let autoScroll;
  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + testimonials.length) % testimonials.length);
  };

  const setSlide = (index) => {
    const slides = document.querySelectorAll('.slide');
    slides.forEach((slide, i) => {
      const isPrev = i === (index - 1 + testimonials.length) % testimonials.length;
      const isNext = i === (index + 1) % testimonials.length;
      const isCurrent = i === index;

      slide.style.transform = `translateX(${isCurrent ? '0' : isPrev ? '-100%' : '100%'
        })`;
      slide.style.opacity = isCurrent ? '1' : '0.5';
      slide.style.zIndex = isCurrent ? '10' : '0';
    });
  };

  const startAutoScroll = () => {
    autoScroll = setInterval(nextSlide, 5000);
  };

  const stopAutoScroll = () => clearInterval(autoScroll);

  useEffect(() => {
    setSlide(currentSlide);
    startAutoScroll();
    return () => clearInterval(autoScroll);
  }, [currentSlide]);

  const sliderRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    const slider = sliderRef.current;
    if (slider) {
      setCanScrollLeft(slider.scrollLeft > 0);
      setCanScrollRight(slider.scrollLeft + slider.clientWidth < slider.scrollWidth);
    }
  };

  const scrollSlider = (direction) => {
    const scrollAmount = 300;
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;
    checkScroll();
    slider.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);
    return () => {
      slider.removeEventListener('scroll', checkScroll);
      window.removeEventListener('resize', checkScroll);
    };
  }, []);

  const [showAll, setShowAll] = useState(false);
  const [showAll2, setShowAll2] = useState(false);
  const [showAll3, setShowAll3] = useState(false);
  const [showAll4, setShowAll4] = useState(false);
  const [showAll5, setShowAll5] = useState(false);
  const [showAll6, setShowAll6] = useState(false);
  const [showAll7, setShowAll7] = useState(false);
  const [showAll8, setShowAll8] = useState(false);

  const features = [
    "Pricing & Promotion Automation",
    "Hosting & Domain Management",
    "Android & iOS Output",
    "Themes & Templates",
    "Drag & Drop Editor",
    "Push Notifications",
    "Loyalty & Rewards",
    "Recommendation",
    "Gen-AI Search",
    "PWA Support",
  ];

  const features2 = [
    "Multi-location Support",
    "Customer Engagement",
    "Accounting & Audit",
    "Billing & Invoicing",
    "Inventory Sync"
  ];

  const features3 = [
    "Warehouse Management",
    "Logistics Management",
    "Inventory Control",
    "Order Fulfillment"
  ];

  const b2bCommerceFeatures = [
    "B2B Commerce",
    "Buyer Portals",
    "Tiered Pricing",
    "Credit & Payment Terms",
    "Logistics Marketplace",
    "Logistics Sale & Purchase",
    "Shipment Tracking",
    "3PL Integrations",
    "Route Optimization",
  ];

  const complianceAndFraudFeatures = [
    "Compliance",
    "Fraud Management",
    "ComplianceDevice Intelligence",
    "AdShield",
    "Audit Trails",
  ];

  const marketingAutomationFeatures = [
    "Marketing Automation",
    "Campaign Builder",
    "Customer Segmentation",
    "WhatsApp/SMS/Email Integration",
  ];

  const analyticsFeatures = [
    "Realtime Customer 360^ & Action",
    "Analytics",
    "Prediction",
    "Simulation",
  ];

  const crmCdpDmsFeatures = [
    "CRM, CDP, DMS",
    "Data Governance",
    "Prediction",
    "Simulation"
  ];

  const visibleFeatures = showAll ? features : features.slice(0, 3);
  const visibleFeatures2 = showAll2 ? features2 : features2.slice(0, 3);
  const visibleFeatures3 = showAll3 ? features3 : features3.slice(0, 3);
  const visibleFeatures4 = showAll4 ? complianceAndFraudFeatures : complianceAndFraudFeatures.slice(0, 3);
  const visibleFeatures5 = showAll5 ? marketingAutomationFeatures : marketingAutomationFeatures.slice(0, 3);
  const visibleFeatures6 = showAll6 ? analyticsFeatures : analyticsFeatures.slice(0, 3);
  const visibleFeatures7 = showAll7 ? crmCdpDmsFeatures : crmCdpDmsFeatures.slice(0, 3);
  const visibleFeatures8 = showAll8 ? b2bCommerceFeatures : b2bCommerceFeatures.slice(0, 3);

  const Textfeatures = [
    {
      icon: <FaRocket className="text-orange-500" />,
      title: 'Startup Launch',
      description: 'Kickstart your business with powerful tools.',
    },
    {
      icon: <FaIndustry className="text-orange-500" />,
      title: 'Manufacturing',
      description: 'Optimized solutions for industries.',
    },
    {
      icon: <FaProjectDiagram className="text-orange-500" />,
      title: 'Tech Integration',
      description: 'Connect your processes seamlessly.',
    },
    {
      icon: <FaChartLine className="text-orange-500" />,
      title: 'Growth Metrics',
      description: 'Track and grow your performance.',
    },
  ];

  const AmazingProduct = [
    {
      title: "Website/App Builder",
      icon: <FaLaptopCode />,
      features: ["Pricing & Promotion Automation", "Hosting & Domain Management"],
    },
    {
      title: "Marketing Automation",
      icon: <FaChartBar />,
      features: ["Pricing & Promotion Automation", "Hosting & Domain Management"],
    },
    {
      title: "Warehouse Management System (WMS)",
      icon: <FaWarehouse />,
      features: ["Pricing & Promotion Automation"],
    },
    {
      title: "B2B Commerce",
      icon: <FaHandshake />,
      features: ["Pricing & Promotion Automation", "Hosting & Domain Management"],
    },
    {
      title: "Point of Sale (POS)",
      icon: <FaStore />,
      features: [
        "Billing & Invoicing",
        "Inventory Sync",
        "Multi-location Support",
        "Customer Engagement",
        "Accounting & Audit",
      ],
    },
    {
      title: "Logistics Marketplace",
      icon: <FaBoxOpen />,
      features: ["Pricing & Promotion Automation", "Hosting & Domain Management"],
    },
    {
      title: "Compliance",
      icon: <FaClipboardCheck />,
      features: ["Pricing & Promotion Automation", "Hosting & Domain Management"],
    },
    {
      title: "Analytics",
      icon: <FaChartPie />,
      features: ["Pricing & Promotion Automation", "Hosting & Domain Management"],
    },
  ];

  const productOverview = [
    {
      title: "Multi-Tenant Architecture",
      description: "Ideal for use across a wide range of industries and applications.",
      icon: Building,
      color: "bg-blue-800",
      position: "top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2",
    },
    {
      title: "Modular Stack",
      description: "Ideal for use across a wide range of industries and applications.",
      icon: Layers,
      color: "bg-purple-700",
      position: "top-1/4 left-0 transform -translate-x-1/2",
    },
    {
      title: "API Integrations",
      description: "Ideal for use across a wide range of industries and applications.",
      icon: Plug,
      color: "bg-red-500",
      position: "bottom-1/4 left-0 transform -translate-x-1/2",
    },
    {
      title: "Security & Compliance",
      description: "Ideal for use across a wide range of industries and applications.",
      icon: ShieldCheck,
      color: "bg-yellow-400",
      position: "bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2",
    },
    {
      title: "Performance & Scalability",
      description: "Ideal for use across a wide range of industries and applications.",
      icon: TrendingUp,
      color: "bg-sky-400",
      position: "top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2",
    },
  ];

  const cardData = [
    {
      type: "BLOG",
      image: "/Slide1.png",
      description: "Lorem ipsum is placeholder text commonly used in the graphic, print.",
      readMore: "Read More"
    },
    {
      type: "CASE STUDIES",
      image: "/Slide2.png",
      description: "Lorem ipsum is placeholder text commonly used in the graphic, print.",
      readMore: "Read More"
    },
    {
      type: "RELEASE NOTES",
      image: "/Slide3.png",
      description: "Lorem ipsum is placeholder text commonly used in the graphic, print.",
      readMore: "Read More"
    },
    {
      type: "BLOG",
      image: "/Slide4.png",
      description: "Lorem ipsum is placeholder text commonly used in the graphic, print.",
      readMore: "Read More"
    },
    {
      type: "BLOG",
      image: "/Slide5.jpg",
      description: "Lorem ipsum is placeholder text commonly used in the graphic, print.",
      readMore: "Read More"
    }
  ];

  const NextArrow = ({ onClick }) => (
    <div
      className="absolute right-0 top-1/2 transform -translate-y-1/2 cursor-pointer z-10"
      onClick={onClick}
    >
      <button className="bg-gray-200 hover:bg-gray-300 p-2 rounded-full shadow"><FaChevronRight /></button>
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div
      className="absolute left-0 top-1/2 transform -translate-y-1/2 cursor-pointer z-10"
      onClick={onClick}
    >
      <button className="bg-gray-200 hover:bg-gray-300 p-2 rounded-full shadow"><FaChevronLeft /></button>
    </div>
  );

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  const Rolecategories = {
    industry: [
      { label: "Retail", icon: <FaShoppingCart className="text-2xl text-blue-500" /> },
      { label: "Manufacturing", icon: <FaCog className="text-2xl text-purple-500" /> },
      { label: "Logistics", icon: <FaTruck className="text-2xl text-red-500" /> },
      { label: "FMCG", icon: <FaBoxOpen className="text-2xl text-yellow-500" /> },
      { label: "Pharma", icon: <FaPrescriptionBottleAlt className="text-2xl text-cyan-500" /> },
    ],
    role: [
      { label: "For Business Owners", icon: <FaUserTie className="text-2xl text-blue-400" /> },
      { label: "For IT Teams", icon: <FaUsers className="text-2xl text-purple-400" /> },
      { label: "For Marketing Teams", icon: <FaBullhorn className="text-2xl text-red-400" /> },
    ],
  };

  return (
    <Layout>
      <HeroVideoSection />
      <BrandSection />

      <section className="bg-gray-100 px-18 pt-20 pb-12">
        <div className="mx-auto sm:w-4/5">
          <div className="text-center">
            <h3 className="font-bold text-5xl">
              Why FIXALL.AI?
            </h3>
            <p className="mt-3 text-xl">Fixall.AI is an AI-native, multi-tenant SaaS technology stack engineered to simplify, automate, and scale every aspect of your digital business.
            </p>
          </div>
          <div className="container mx-auto px-4 py-10">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {Textfeatures?.map((feature, index) => (
                <div
                  key={index}
                  className="flex hoverItem items-start bg-white p-5 rounded-xl card border border-gray-200"
                >
                  <div className="w-12 featuresIcon h-12 bg-orange-100 text-xl flex items-center justify-center rounded-lg mr-4">
                    {feature.icon}
                  </div>
                  <div>
                    <h6 className="font-semibold text-gray-800">{feature.title}</h6>
                    <p className="text-sm text-gray-600">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center mt-8">
              <Link to='/contact'>
                <button
                  className="hover:bg-blue-700 text-white px-6 py-2 rounded-full shadow-md transition"
                  style={{ background: 'rgb(116, 83, 224)' }}
                >
                  Contact Us
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>


      {/* product Overview  */}

      <section className="pt-12">
        <h2 className="text-4xl font-bold text-black text-center">Platform and Product Overview</h2>
        <div className="flex flex-col md:flex-row items-center flex-row-reverse justify-center gap-12 px-4 md:px-20 bg-white">
          <div className="w-full md:w-1/2 space-y-6">
            {productOverview.map((feature, index) => (
              <div key={index} className="flex items-center space-x-4">
                <div className={`w-12 h-12 ${feature.color} rounded-full flex items-center justify-center`}>
                  <feature.icon className="text-white w-6 h-6" />
                </div>
                <div>
                  <h4 className="font-semibold">{feature.title}</h4>
                  <p className="text-sm text-gray-600">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="relative w-[450px] h-[450px] flex items-center justify-center">
            <div className="w-full h-full rounded-full flex items-center justify-center relative">
              <div className="absolute w-32 h-32 rounded-full bg-white border-2 border-gray-300 flex items-center justify-center z-10">
                <img
                  src="/fixalllogo 1.png"
                  alt="Logo"
                  className="w-20 h-20 object-contain"
                />
              </div>

              <div className="relative w-[400px] h-[400px] flex items-center justify-center rounded-full border-gray-200">
                <div className="absolute bg-white border-2 border-gray-200 rounded-full flex items-center justify-center shadow-lg z-10">
                  <img
                    src="/overview.png"
                    alt="Logo"
                    className="w-100 h-100 object-contain"
                  />
                </div>
                <div className="flex items-center w-20 h-20 justify-center z-10">
                  <img
                    src="/fixalllogo 1.png"
                    alt="Logo"
                    className="w-[100px] h-[100px] object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* end product Overview  */}

      <section className="py-10">
        <div
          className="text-white py-12 px-4 md:px-20"
          style={{ background: "rgba(59, 109, 182, 1)" }}
        >
          <h2 className="text-3xl font-bold text-center mb-10">Amazing Products</h2>
          <div className="flex gap-6">
            <div className="w-full flex flex-col gap-6">
              {AmazingProduct.slice(0, 3).map((product, index) => (
                <div
                  key={index}
                  className="rounded-xl boxHoverEffect p-5 shadow hover:shadow-xl transition flex gap-4"
                  style={{ border: "1px solid #ddd" }}
                >
                  <div className="text-3xl mb-4">{product.icon}</div>
                  <div className="flex flex-col">
                    <h3 className="text-md font-semibold mb-3">{product.title}</h3>
                    <ul className="list-disc pl-5 space-y-1 text-sm">
                      {product.features.map((feature, idx) => (
                        <li key={idx}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>

            <div className="w-full flex flex-col gap-6">
              {AmazingProduct.slice(3, 5).map((product, index) => (
                <div
                  key={index}
                  className="rounded-xl boxHoverEffect p-5 shadow hover:shadow-xl transition gap-4 flex"
                  style={{ border: "1px solid #ddd" }}
                >
                  <div className="text-3xl mb-4">{product.icon}</div>
                  <div className="flex flex-col">
                    <h3 className="text-md font-semibold mb-3">{product.title}</h3>
                    <ul className="list-disc pl-5 space-y-1 text-sm">
                      {product.features.map((feature, idx) => (
                        <li key={idx}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>

            <div className="w-full flex flex-col gap-6">
              {AmazingProduct.slice(5, 8).map((product, index) => (
                <div
                  key={index}
                  className="rounded-xl boxHoverEffect p-5 shadow hover:shadow-xl flex gap-4 transition"
                  style={{ border: "1px solid #ddd" }}
                >
                  <div className="text-3xl mb-4">{product.icon}</div>
                  <div className="flex flex-col">
                    <h3 className="text-md font-semibold mb-3">{product.title}</h3>
                    <ul className="list-disc pl-5 space-y-1 text-sm">
                      {product.features.map((feature, idx) => (
                        <li key={idx}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-16" style={{ display: "none" }}>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-gray-800 mb-8 text-center">By Industry</h2>
        <div className="flex gap-6">
          <div class="spectacledcoder-card2">
            <div class="circle2"></div>
            <img width="25" height="25" src="https://img.icons8.com/ios-filled/100/ffffff/codepen.png" alt="codepen" />
            <p class="content">Retail</p>
          </div>

          <div class="spectacledcoder-card2">
            <div class="circle2"></div>
            <img width="25" height="25" src="https://img.icons8.com/ios-filled/100/ffffff/codepen.png" alt="codepen" />
            <p class="content">Manufacturing</p>
          </div>

          <div class="spectacledcoder-card2">
            <div class="circle2"></div>
            <img width="25" height="25" src="https://img.icons8.com/ios-filled/100/ffffff/codepen.png" alt="codepen" />
            <p class="content">Logistics</p>
          </div>

          <div class="spectacledcoder-card2">
            <div class="circle2"></div>
            <img width="25" height="25" src="https://img.icons8.com/ios-filled/100/ffffff/codepen.png" alt="codepen" />
            <p class="content">FMCG</p>
          </div>

          <div class="spectacledcoder-card2">
            <div class="circle2"></div>
            <img width="25" height="25" src="https://img.icons8.com/ios-filled/100/ffffff/codepen.png" alt="codepen" />
            <p class="content">Pharma</p>
          </div>
        </div>
      </section>

      <section className="py-16 px-16">
        <div className="flex gap-5 relative">
          <div className="flex relative justify-center items-center space-x-4" style={{ width: "30%" }}>
            <div className="w-[150px] h-[150px] border border-gray-300 rounded-full flex items-center justify-center">
              <img src="/logo.png" className="mx-auto max-w-full max-h-full" alt="Logo" />
            </div>
            <div className="absolute" style={{ top: "0px" }}>
              <button className="w-32 py-2 px-4 bg-white-800 shadow-md  text-dark rounded-md transition">
                By Industry
              </button>
            </div>
            <div className="absolute" style={{ bottom: "0px" }}>
              <button className="w-32 py-2 px-4 bg-white text-dark shadow-md text-dark rounded-md transition">
                By Role
              </button>
            </div>
          </div>

          <div style={{ width: "100%" }}>
            <div className="flex flex-col items-center gap-20">
              <div className="gap-6" style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr" }}>
                {Rolecategories.industry.map(({ label, icon }) => (
                  <div key={label} className="border flex flex-col items-center bg-white rounded-xl shadow-md px-4 py-5">
                    <span style={{ fontSize: "30px" }}>{icon}</span>
                    <span className="mt-2 text-sm font-medium text-center">{label}</span>
                  </div>
                ))}
              </div>

              <div className="flex gap-4 justify-center flex-wrap">
                {Rolecategories.role.map(({ label, icon }) => (
                  <div key={label} className="w-40 border flex flex-col items-center bg-white rounded-xl shadow-md px-4 py-3">
                    <span style={{ fontSize: "30px" }}>
                      {icon}
                    </span>
                    <span className="mt-2 text-sm font-medium text-center">{label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-6 absolute" style={{ top: "50%", left: "58%", width: "80%", transform: "translate(-50%, -50%)" }}>
            <div className="w-full">
              <img src="vector1.png" className="w-full" />
            </div>
            <div className="w-full">
              <img src="vector2.png" className="w-full" />
            </div>
          </div>
        </div>
      </section>
      
      {/*
      <div className="px-16 py-12 bg-[#f9f9f9]">
        <h2 className="text-2xl font-bold mb-5 text-center">All Resources you need</h2>
        <Slider {...settings}>
          {cardData.map((card, index) => (
            <div key={index} className="p-3">
              <div className="bg-white relative rounded-lg overflow-hidden shadow-md">
                <img src={card.image} alt="Card" className="w-full h-40 object-cover" />
                <span className="text-xs absolute font-semibold text-white bg-blue-500 px-2 py-1 rounded" style={{ top: "0.5rem", left: "0.5rem" }}>
                  {card.type}
                </span>
                <div className="p-4">
                  <p className="mt-2 text-sm text-gray-700">{card.description}</p>
                  <button className="mt-4 text-green-600 hover:underline">{card.readMore} →</button>
                </div>
              </div>
            </div>
          ))}
        </Slider>
        <div className="mt-6 text-center">
          <button className="text-white px-6 py-2 rounded-full" style={{ background: "rgb(116, 83, 224)" }}>
            Read More Blog
          </button>
        </div>
      </div>
      */}

      <div className="relative overflow-hidden text-white py-16 px-4 text-center">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url('/bgImg.png')" }}
        ></div>

        <div className="absolute inset-0 opacity-40" style={{ background: "#e2861e" }}></div>
        <div className="relative z-10">
          <h1 className="text-4xl font-bold mb-2">Start Building with Fixall.AI</h1>
          <p className="text-lg mb-10">
            Fixall.AI adapts to you and grows your business seamlessly.
          </p>

          <div className="flex flex-col md:flex-row justify-center gap-10 mb-10 px-22">
            <div className="flex flex-col items-center" style={{ width: "33.3%" }}>
              <div className="bg-white text-orange-500 p-4 rounded-full mb-2">
                <FaStore className="text-2xl" />
              </div>
              <p>Launch a store<br /><b>in 30 mins</b></p>
            </div>

            <div className="flex flex-col items-center" style={{ width: "33.3%" }}>
              <div className="bg-white text-orange-500 p-4 rounded-full mb-2">
                <FaStoreAlt className="text-2xl" />
              </div>
              <p>Scale to 1000+ <br /><b>outlets</b> or sellers</p>
            </div>

            <div className="flex flex-col items-center" style={{ width: "33.3%" }}>
              <div className="bg-white text-orange-500 p-4 rounded-full mb-2">
                <FaChartLine className="text-2xl" />
              </div>
              <p>
                Run marketing, fulfillment,<br />
                compliance, and growth all from<br />
                <b>one AI console</b>
              </p>
            </div>
          </div>

          
          <div className="flex flex-col md:flex-row justify-center gap-4">
            {/*
            <div className="" style={{ width: "25%" }}>
              <button className="bg-green-400 hover:bg-green-500 text-white py-2 px-4 w-full rounded-full">
                Start Free Trial
              </button>
            </div>
            */}
            <div className="" style={{ width: "25%" }}>
              <Link to='/request-demo'>
                <button className="bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-full w-full">
                  Schedule a Live Demo
                </button>
              </Link>
            </div>
            {/*
            <div className="" style={{ width: "25%" }}>
              <button className="bg-teal-600 hover:bg-teal-700 text-white py-2 px-4 rounded-full w-full">
                Download Architecture Whitepaper
              </button>
            </div>
            */}
          </div>
        </div>
      </div>

      <section className="py-10 bg-[#F7F5FF]" style={{ display: "none" }}>
        <div className="w-full max-w-screen-xl xl:max-w-screen-xl px-4 mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-gray-800 mb-10">
            Everything you need for growth
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 lg:gap-10">
            {products.map((product, index) => (
              <Link to={product.link} key={product.id}>
                <div
                  key={index}
                  className="bg-white rounded-sm shadow-sm p-6 flex items-center justify-center h-32"
                >
                  <img
                    src={product.imgSrc}
                    alt={product.alt}
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Rotated Border Animation Div */}
      <div class="flex w-full flex-col items-center justify-center bg-pink-100 px-5 py-14 md:px-8 lg:py-32 md:py-28" style={{ display: "none" }}>
        <div className='w-full relative md:w-[80%] lg:w-[70%] xl:w-[80%]  max-w-screen-md h-40 md:h-64 lg:h-96 rounded-[75px] md:rounded-[500px]'>
          <div class="card-wrapper overflow-hidden  absolute w-full h-full left-0 rounded-full  ">
          </div>
          <div class=" h-full w-full top-0 bottom-0 absolute z-10 ">
            <div class="card-content  flex items-center justify-center text-xs rounded-[75px] md:rounded-[500px]" />
            <div className="text-center absolute left-1/2 top-[45%] transform -translate-x-1/2 -translate-y-1/2 w-full">
              <h2 className="text-red-400 sm:text-3xl font-semibold text-lg sm:mb-3 mb-1">Manage</h2>
              <p className="mb-3 font-semibold xl:text-2xl lg:text-xl md:text-lg text-base">From shopping carts to content customers</p>
              <p className="font-semibold xl:text-2xl lg:text-xl md:text-lg text-base">your entire order cycle, automated</p>
            </div>
            <div className="absolute top-[-30px] left-[20%] lg:top-[-65px] lg:left-[20%] flex flex-col items-center justify-center">
              <p className="text-sm md:text-base font-semibold mb-2 text-center hidden lg:block">
                Online Order Placed
              </p>
              <div className="animate-scale-image-1 bg-[#ffd8ce] rounded-full w-10 h-10 md:w-16 md:h-16 lg:w-20 lg:h-20 flex items-center justify-center p-2 shadow-md">
                <img
                  src="/shoes.png"
                  alt="Seller App Icon"
                  className=""
                />
              </div>
            </div>
            <div className="absolute top-[-30px] left-[62%] lg:top-[-65px] lg:left-[65%] flex flex-col items-center justify-center">
              <p className="text-sm md:text-base font-semibold mb-2 text-center hidden lg:block">
                Payment Received
              </p>
              <div className="animate-scale-image-2 bg-[#d8f6e6] rounded-full w-10 h-10 md:w-16 md:h-16 lg:w-20 lg:h-20 flex items-center justify-center p-2 shadow-md">
                <img
                  src="/creditCard.png"
                  alt="Seller App Icon"
                  className=""
                />
              </div>
            </div>
            <div className="absolute top-[42%] -left-[4%] lg:top-[42%] lg:-left-[17%] flex items-center">
              <p className="text-sm md:text-base font-semibold mr-2 text-center hidden lg:block">
                Happy <br /> Customer +1
              </p>
              <div className="animate-scale-image-6 bg-[#d8f6e6] rounded-full w-10 h-10 md:w-16 md:h-16 lg:w-20 lg:h-20 flex items-center justify-center p-2 shadow-md">
                <img
                  src="/heart.png"
                  alt="Analytics"
                  className="object-contain w-full h-full"
                />
              </div>
            </div>
            <div className="absolute top-[42%] -right-[5%] lg:top-[42%] lg:-right-[20%] flex items-center">
              <div className="animate-scale-image-3 bg-[#ffdad0] rounded-full w-10 h-10 md:w-16 md:h-16 lg:w-20 lg:h-20 flex items-center justify-center p-2 shadow-md">
                <img
                  src="/inventoryCheck.png"
                  alt="Seller Apps"
                  className="object-contain w-full h-full"
                />
              </div>
              <p className="text-sm md:text-base font-semibold ml-2 text-center hidden lg:block">
                Inventory levels <br /> updated
              </p>
            </div>
            <div className="absolute bottom-[-20px] left-[20%] lg:bottom-[-85px] lg:left-[20%] flex flex-col items-center justify-center">
              <div className="animate-scale-image-5 bg-white rounded-full w-10 h-10 md:w-16 md:h-16 lg:w-20 lg:h-20 flex items-center justify-center p-2 shadow-md">
                <img
                  src="deliverBox.png"
                  alt="Shipping Icon"
                  className="object-contain w-full h-full"
                />
              </div>
              <p className="text-xs md:text-sm font-semibold mt-2 text-center hidden lg:block">
                Product Delivered to <br /> the customer
              </p>
            </div>
            <div className="absolute bottom-[-20px] left-[65%] lg:-bottom-[85px] lg:left-[65%] flex flex-col items-center justify-center">
              <div className="animate-scale-image-4 bg-[#f2f2f2] rounded-full w-10 h-10 md:w-16 md:h-16 lg:w-20 lg:h-20 flex items-center justify-center p-2 shadow-md">
                <img
                  src="/shipped.png"
                  alt="Shipping Icon"
                  className="object-contain w-full h-full"
                />
              </div>
              <p className="text-xs md:text-sm font-semibold mt-2 text-center hidden lg:block">
                Products shipped <br /> & tracked
              </p>
            </div>
          </div>
        </div>
      </div>

      <section style={{ display: "none" }}>
        <div className="container mx-auto  p-4">
          <div className="relative flex items-center justify-center overflow-hidden h-[350px]">
            {/* Prev Button */}
            <button
              onClick={prevSlide}
              className="absolute left-0 bg-white border border-gray-300 rounded-full w-10 h-10 flex items-center justify-center hover:bg-gray-100 transition-colors z-20"
            >
              <svg className="w-6 h-6 rotate-90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {/* Slides Container */}
            <div className="flex space-x-4 items-center justify-center">
              {[-1, 0, 1].map(offset => {
                const index = (currentSlide + offset + testimonials.length) % testimonials.length;
                const isCenter = offset === 0;
                return (
                  <TestimonialSlide
                    key={index}
                    quote={testimonials[index].quote}
                    name={testimonials[index].name}
                    title={testimonials[index].title}
                    img={testimonials[index].img}
                    color={testimonials[index].color}
                    isCenter={isCenter}
                  />
                );
              })}
            </div>


            {/* Next Button */}
            <button
              onClick={nextSlide}
              className="absolute right-0 bg-white border border-gray-300 rounded-full w-10 h-10 flex items-center justify-center hover:bg-gray-100 transition-colors z-20"
            >
              <svg className="w-6 h-6 -rotate-90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          </div>

          {/* Dots */}
          {/* <div
            className="flex justify-center mt-4 space-x-2"
            onMouseEnter={stopAutoScroll}
            onMouseLeave={startAutoScroll}
          >
            {testimonials.map((_, index) => (
              <div
                key={index}
                className={`w-3 h-3 rounded-full cursor-pointer ${currentSlide === index ? 'bg-indigo-800' : 'bg-gray-300'}`}
                onClick={() => {
                  setCurrentSlide(index);
                  setSlide(index);
                }}
              ></div>
            ))}
          </div> */}
        </div>
      </section>

      <section class="bg-[#00A69C] border text-white relative" style={{ display: "none" }}>
        <div class="items-start max-w-screen-xl xl:max-w-screen-2xl gap-2 px-4 py-8 mx-auto lg:pt-10 lg:pb-6 lg:px-6 flex flex-col lg:flex-row">
          <div class="w-full lg:w-1/2 lg:border-r-[1px] lg:pr-10 flex flex-col items-center lg:items-start lg:justify-start">
            <p class="text-3xl font-medium text-white ">
              Trusted Worldwide
            </p>
            <h2 class="mt-3 mb-4 md:tracking-wider text-2xl font-medium md:font-bold lg:font-extrabold tracking-tight text-white md:text-2xl capitalize text-center lg:text-left">
              Trusted by over 3000 clients and 30+ agency partners
            </h2>
            <p class="text-white sm:text-xl border-y border-gray-200 py-5 text-center lg:text-left">
              Our rigorous security and compliance standards are at the heart of
              all we do. We work tirelessly to protect you and your customers.
            </p>
            <div class="flex lg:flex-col lg:items-start lg:justify-start justify-between w-full sm:w-3/5">
              <Link to="/ourstory" className="max-w-64 lg:w-60 border border-white rounded-sm mt-8 bg-[#00A69C] text-white hover:bg-white hover:text-[#00A69C] hover:border-[#00A69C] transition-all duration-300">
                <button className={`flex items-center justify-center gap-2 px-4 py-2 rounded-sm font-semibold text-sm md:text-base`}>
                  Explore Legality Guide
                  <MdOutlineChevronRight className="slideRight mt-1" fontSize="large" />
                </button>
              </Link>
              <Link to="/ourstory" className="max-w-64 lg:w-60 border border-white rounded-sm mt-8 bg-[#00A69C] text-white hover:bg-white hover:text-[#00A69C] hover:border-[#00A69C] transition-all duration-300">
                <button className={`flex items-center justify-center gap-2 px-4 py-2 rounded-sm font-semibold text-sm md:text-base`} >
                  Visit the Trust Center
                  <MdOutlineChevronRight className="slideRight mt-1" fontSize="large" />
                </button>
              </Link>
            </div>
          </div>
          <div ref={sectionRef} class="w-full lg:w-1/2 grid-cols-2 grid lg:pl-5">
            <div className="flex flex-col gap-2 items-center justify-center p-2">
              <img src="/partners.png" alt="uptime" className="h-12 w-12 object-cover invert " />
              <h3 class="mb-2 text-xl md:text-2xl font-semibold md:font-bold w-full text-center">
                <span className="inline-block sm:w-16 w-14 text-right">{counters.uptime}</span><span className="inline-block xl:w-36 xl:text-left">+ Partners</span>
              </h3>
              <p class="text-white min-h-20 text-center">
                Across various sectors and geographies
              </p>
            </div>
            <div className="flex flex-col gap-2 items-center justify-center p-2">
              <img src="/user.png" alt="users" className="h-12 w-12 object-cover " />

              <h3 class="mb-2 text-xl md:text-2xl font-semibold md:font-bold w-full text-center">
                <span className="inline-block sm:w-16 w-14 text-right">{counters.users}</span><span className="inline-block xl:w-36 xl:text-left">+ Clients</span>
              </h3>
              <p class="text-white min-h-20 text-center">
                Trusted by over 3K clients around the world
              </p>
            </div>
            <div className="flex flex-col gap-2 items-center justify-center p-2">
              <img src="/countries.png" alt="countries" className="h-12 w-12 object-cover " />

              <h3 class="mb-2 text-xl md:text-2xl font-semibold md:font-bold w-full text-center">
                <span className="inline-block sm:w-16 text-right">{counters.countries}</span><span className="inline-block xl:w-36 xl:text-left">+ Countries</span>
              </h3>
              <p class="text-white min-h-20 text-center">
                Have used Fixall to create functional websites
              </p>
            </div>
            <div className="flex flex-col gap-2 items-center justify-center p-2">
              <img src="/transaction.png" alt="transaction" className="h-12 w-12 object-cover " />

              <h3 class="mb-2 text-xl md:text-2xl font-semibold md:font-bold w-full text-center">
                <span className="inline-block sm:w-16 w-10 -ml-6 sm:ml-0 text-right">{counters.transactions}</span><span className="inline-block sm:w-36 sm:text-left">+ Projects</span>
              </h3>
              <p class="text-white min-h-20 text-center">
              Projects delivered across life time
              </p>
            </div>
          </div>
        </div>
        <img src="/monumentsGroup.png" alt="groups" className="absolute -bottom-4 right-0" />
      </section>

      <section className="" style={{ display: "none" }}>
        <div className="">
          <img src="/employees.png" alt="Employees" className="xl:h-[450px] w-full object-cover" />
        </div>
        <div className="bg-[#F7F5FF] w-full">
          <div className=" text-center w-full max-w-screen-xl xl:max-w-screen-2xl p-8 mx-auto">
            <h2 className="font-semibold text-2xl md:3xl lg:text-4xl capitalize">The core values and principles that drive us</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center mt-10">
              <div className="bg-white flex flex-col gap-2 md:gap-4 rounded-lg justify-center align-middle items-center p-5 lg:p-8 sm:px-6 sm:py-4">
                <div className="h-14 w-14 md:h-24 md:w-24">
                  <img src="/vision.png" alt="vision" className="h-[100%] w-[100%] object-cover"></img>
                </div>
                <h3 className="text-lg md:text-xl font-semibold">Vision</h3>
                <p className="text-sm md:text-base sm:min-h-32 min-h-20">25+ years of running a profitable organization gives us a good sense of challenges that a growing business faces. We take pride in running a sustainable business that’s powered by you, our customer.</p>
              </div>
              <div className="bg-white flex flex-col gap-2 md:gap-4 rounded-lg justify-center align-middle items-center p-5 lg:p-8 sm:px-6 sm:py-4">
                <div className="h-14 w-14 md:h-24 md:w-24">
                  <img src="/mission.png" alt="" className="h-[100%] w-[100%] object-cover"></img>
                </div>
                <h3 className="text-lg md:text-xl font-semibold">Mission</h3>
                <p className="text-sm md:text-base sm:min-h-32 min-h-20">Software is our craft and we back it up with our relentless investments in R&D. So much so that we prefer to own the entire technology stack, including running our data centers globally.</p>
              </div>
              <div className="bg-white flex flex-col gap-2 md:gap-4 rounded-lg justify-center align-middle items-center p-5 lg:p-8 sm:px-6 sm:py-4">
                <div className="h-14 w-14 md:h-24 md:w-24">
                  <img src="/coreValues.png" alt="core-values" className="h-[100%] w-[100%] object-cover"></img>
                </div>
                <h3 className="text-lg md:text-xl font-semibold">Core Values</h3>
                <p className="text-sm md:text-base sm:min-h-32 min-h-20">In all these years, it's our customers' trust and goodwill that has helped us establish a strong position in the market. No matter the size of your business, we're here to help you grow.</p>
              </div>
            </div>
            {/* <div className="flex items-center justify-center mt-8">
            <Link to="/ourstory">
              <button className="bg-[#7453E0] text-white font-semibold md:text-base text-sm px-4 py-2 rounded-sm flex items-center justify-center gap-2">
                Read Our Story
                <MdOutlineChevronRight />
              </button>
            </Link>
          </div> */}
            <CustomButton to="/ourstory" label="Read Our Story" />


          </div>
        </div>
      </section>

    </Layout>
  );
};

export default Home;



const TestimonialSlide = ({ quote, name, title, img, color, isCenter }) => (
  <div
    className={`flex flex-col items-center justify-center p-6 rounded-2xl shadow-lg min-h-[300px] transition-all duration-300 ease-in-out w-[300px] md:w-[350px] ${isCenter ? 'scale-105 z-10' : 'scale-95 opacity-60'
      }`}
    style={{ background: color }}
  >
    <div className="text-indigo-900 text-xl font-bold mb-2">{name}</div>
    <p className="text-gray-800 text-lg text-center mb-6 max-w-md">{`"${quote}"`}</p>
    <div className="flex items-center">
      <img src={img} alt={name} className="w-12 h-12 rounded-full mr-4 object-cover" />
      <div className="text-left">
        {/* <p className="font-semibold text-lg">{name}</p> */}
        <p className="text-gray-600 text-base">{title}</p>
      </div>
    </div>
  </div>
);
